import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function StripePricingTable() {
    const navigate = useNavigate();

    useEffect(() => {
        // Load Stripe Pricing Table script
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/pricing-table.js';
        script.async = true;
        document.head.appendChild(script);

        return () => {
            // Cleanup script when component unmounts
            if (document.head.contains(script)) {
                document.head.removeChild(script);
            }
        };
    }, []);

    // Handle successful subscription
    useEffect(() => {
        const handleSuccessfulSubscription = (event) => {
            if (event.data && event.data.type === 'stripe_pricing_table_checkout_success') {
                // Redirect to dashboard after successful subscription
                navigate('/dashboard?payment=success');
            }
        };

        window.addEventListener('message', handleSuccessfulSubscription);
        
        return () => {
            window.removeEventListener('message', handleSuccessfulSubscription);
        };
    }, [navigate]);

    return (
        <React.Fragment>
            <section className="relative py-20 min-h-screen">
                <img className="hidden lg:block absolute top-0 left-0 mt-16 z-10" src="zeus-assets/icons/dots/blue-dot-left-bars.svg" alt />
                <div className="absolute top-0 left-0 bottom-0 w-full bg-gray-50" />
                <div className="relative container px-4 mx-auto">
                    <div className="flex flex-col items-center justify-center">
                        <div className="w-full max-w-lg px-4 mb-12 text-center">
                            <h2 className="mb-10 text-4xl font-semibold font-heading">Choose Your Plan</h2>
                            <p className="text-xl text-gray-500">Select the plan that best fits your needs and get started with Ordio today.</p>
                        </div>
                        
                        <div className="w-full max-w-4xl px-4">
                            <div className="bg-white rounded-xl p-6 shadow-lg">
                                {/* Stripe Pricing Table */}
                                <stripe-pricing-table 
                                    pricing-table-id={process.env.REACT_APP_STRIPE_PRICING_TABLE_ID || "prctbl_1234567890"}
                                    publishable-key={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "pk_test_your_key"}
                                    customer-email=""
                                    success-url={`${window.location.origin}/dashboard?payment=success`}
                                    cancel-url={`${window.location.origin}/plan-selection`}
                                ></stripe-pricing-table>
                            </div>
                            
                            <div className="mt-8 text-center">
                                <button
                                    onClick={() => navigate('/plan-selection')}
                                    className="text-red-400 hover:underline text-sm"
                                >
                                    ← Back to custom plan selection
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}
